import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/imports/')({
  beforeLoad: ({ context }): void => {
    if (context.permissions.isReady && !context.permissions.hasPermission('orders:write')) {
      throw redirect({ to: '/' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/imports/pages/import-page')),
});
